import { EntityState } from '@ngrx/entity';
import { NotificationToast } from '../NotificationToast.interface';

export interface NotificationState extends EntityState<NotificationToast> {}
